<template>
  <div class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/pages">{{textContent.title}}</router-link>
          <span></span>
          <h1>{{copyItem.title}}</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="folder radius" v-if="isLoaded">
          <div class="column caption">
            <p>Редактирование страницы</p>
          </div>
          <div class="column">
            <div class="content">
              <new-input title="Заголовок страницы (h1)" name="title"></new-input>
              <edit-file class="short align-top" use-case="seo" v-if="isLoaded" title="Изображение"
                         name="seo_image"></edit-file>
              <edit-file class="short align-top" use-case="banner" v-if="isLoaded" title="Баннер"
                        name="banner_image"></edit-file>

              <div class="checkbox-group">
                <checkbox name="show_banner" title="Показывать баннер"></checkbox>
                <br/>
              </div>
              <new-input title="Название страницы (title)" name="seo_title"></new-input>
              <new-text-area title="Описание страницы" name="description"></new-text-area>
              <new-text-area title="Ключевые слова" name="keywords"></new-text-area>
            </div>
          </div>
        </div>
        <insert-album @insertAlbum="insertAlbum($event)"></insert-album>
        <div class="folder radius">
          <div class="column caption">
            <p>Текст статьи</p>
          </div>
          <div class="column">
            <div class="content">
              <div :class="{saved: savedFields.hasOwnProperty('text') && !changedText}">
                <textarea id="editor" name="editor" v-model="text"></textarea>
                <add-image v-if="isLoaded"/>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onSubmit">{{textContent.saveButton}}</button>
          <button class="cancel" @click="reset">{{textContent.cancelButton}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IconUpload from '@/components/icons/IconUpload'
  import NewTextArea from '@/components/edit-form/new-items/TextArea'
  import NewInput from '@/components/edit-form/new-items/Input'
  import OldInput from '@/components/edit-form/old-items/Input'
  import OldTextArea from '@/components/edit-form/old-items/TextArea'
  import OldEditor from '@/components/edit-form/old-items/Editor'
  import EditDropDown from '@/components/edit-form/DropDown'
  import EditFile from '@/components/edit-form/File'
  import InsertAlbum from '@/components/edit-form/InsertAlbum'
  import AddImage from '@/components/edit-form/AddImage'
  import Checkbox from "@/components/edit-form/Checkbox";
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')

  export default {
    data: function () {
      return {
        isLoaded: false,
        editorInstance: '',
        text: '',
        editor: null,
        changedText: false,
        editorConfig: {
          language: 'ru',
          ckfinder: {
            uploadUrl: this.$store.state.apiDomain + this.$store.state.ckfinderUrl,
            token: localStorage.token
          }
        }
      }
    },
    computed: {
      ...mapState([
        'item',
        'copyItem',
        'textContent',
        'savedFields'
      ]),
      apiUrls () {
        return this.$store.state.apiUrls
      }
    },
    methods: {
      ...mapActions([
        'init',
        'edit',
        'reset'
      ]),
      ...mapMutations([
        'setFileExtensions',
        'setEditorInstance'
      ]),
      insertAlbum (code) {
        this.editor.insertText(code)
      },
      onEditorReady (editor) {
        this.editorInstance = editor
      },
      onSubmit () {
        this.edit({
          title: this.item.title,
          seo_title: this.item.seo_title,
          seo_image: this.item.seo_image,
          banner_image: this.item.banner_image,
          show_banner: this.item.show_banner,
          description: this.item.description,
          keywords: this.item.keywords,
          text: this.editor.getData(),
        })
      }
    },
    created () {
      this.setFileExtensions({seo_image: ['jpg', 'jpeg', 'png', 'gif'], banner_image: ['jpg', 'jpeg', 'png', 'gif']})
      this.init({
        textContent: {
          title: 'Страницы',
          cancelButton: 'Отмена',
          saveButton: 'Сохранить',
          greeting: 'Все изменения успешно сохранены',
          subtitle: 'Редактирование автора',
          seo: 'SEO информация',
          options: 'Прочие настройки',
        },
        errors: {
          title: {message: 'Введите название страницы', hasError: false},
          seo_title: {message: 'Введите название страницы', hasError: false},
          text: {isNullable: true, hasError: false},
          description: {isNullable: true, hasError: false},
          keywords: {isNullable: true, hasError: false},
          show_banner: {isNullable: true, hasError: false},
          seo_image: {message: 'Допустимые расширения: jpg, jpeg, png, gif', hasError: false, isNullable: true},
          banner_image: {message: 'Допустимые расширения: jpg, jpeg, png, gif', hasError: false, isNullable: true},
        },
        itemId: this.$route.params.id,
        apiUrl: this.apiUrls.pages
      }).then((data) => {
        if (data.text) {
          this.text = data.text
        } else {
          this.text = ''
        }
        this.isLoaded = true
        this.editor = CKEDITOR.replace('editor')
        this.editor.on('change', () => {
          this.changedText = true
        })
        this.setEditorInstance(this.editor)
      })
    },
    components: {
      NewTextArea,
      NewInput,
      OldInput,
      OldTextArea,
      OldEditor,
      EditDropDown,
      EditFile,
      IconUpload,
      InsertAlbum,
      AddImage,
      Checkbox
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/pages/pages/Edit.vue